import { useState } from 'react';
import toast from 'react-hot-toast';
import { authApi } from '@/services/api';
import { LoadingSpinner } from '@/components/common';

interface TwoFactorDisableProps {
  onComplete: () => void;
  onCancel: () => void;
}

export default function TwoFactorDisable({ onComplete, onCancel }: TwoFactorDisableProps) {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!password) {
      toast.error('Ingresa tu contraseña');
      return;
    }

    setLoading(true);
    try {
      await authApi.disable2fa(password);
      toast.success('2FA desactivado');
      onComplete();
    } catch (error: unknown) {
      const message = (error as { response?: { data?: { error?: string } } })?.response?.data?.error || 'Error al desactivar 2FA';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900">Desactivar 2FA</h3>
        <p className="text-sm text-gray-500 mt-1">
          Para desactivar la autenticación de dos factores, confirma tu contraseña.
        </p>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <p className="text-sm text-amber-800">
          <strong>Atención:</strong> Desactivar 2FA reducirá la seguridad de tu cuenta. Solo se requerirá tu contraseña para iniciar sesión.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="label">Contraseña actual</label>
          <input
            type="password"
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            required
          />
        </div>

        <div className="flex gap-3">
          <button type="button" onClick={onCancel} className="btn-secondary flex-1">
            Cancelar
          </button>
          <button type="submit" className="btn-danger flex-1" disabled={loading || !password}>
            {loading ? <LoadingSpinner size="sm" /> : 'Desactivar 2FA'}
          </button>
        </div>
      </form>
    </div>
  );
}
